import React from 'react'

import Spacer from '../../../../components/atoms/Spacer'
import HamburgerMenuV2 from '../../../../components/molecules/HamburgerMenuV2'

import useStyles from './styles'

interface MobileAgentPageTitleProps {
  title: string
  children?: React.ReactNode
}

const MobileAgentPageTitle: React.FC<MobileAgentPageTitleProps> = ({
  title,
  children
}) => {
  const [open, setOpen] = React.useState(false)
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <HamburgerMenuV2 open={open} setOpen={setOpen} className={classes.menu} />
      <div className={classes.title}>{title}</div>

      <Spacer />

      {children}
    </div>
  )
}

export default MobileAgentPageTitle
